import React, { useMemo } from "react";
import { DateCalendar, DateCalendarProps, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { fr, enUS, es } from "date-fns/locale";
import { useSelector } from "react-redux";
import DropDown from "../../drop-down/DropDown";
import { CustomButton } from "../../buttons";
import styles from "./CustomDateCalendarPopUp.module.css";
import { translate } from "../../../providers";
import { HorizontalDivider } from "../..";

interface CustomDateCalendarPopUpProps {
	onChange: DateCalendarProps<Date>["onChange"];
	onClose?: ((event: MouseEvent | TouchEvent, ref: React.RefObject<HTMLElement>) => void) | null;
	onSubmit?: () => void;
	open?: boolean;
	submitButtonText?: string;
	value: Date | null;
}

const CustomDateCalendarPopUp = React.forwardRef<HTMLElement, CustomDateCalendarPopUpProps>(
	({ onChange, onClose = null, onSubmit = undefined, open = false, submitButtonText = "", value }, ref) => {
		const langValue = useSelector(({ context }) => context.language);
		const languageSelector = useMemo(() => {
			if (langValue.value === "en") return enUS;
			if (langValue.value === "fr") return fr;
			if (langValue.value === "esp") return es;
			return enUS;
		}, [langValue]);
		return (
			<DropDown ref={ref} open={open} onClose={onClose}>
				<div>
					<LocalizationProvider adapterLocale={languageSelector} dateAdapter={AdapterDateFns}>
						<DateCalendar value={value} onChange={onChange} />
					</LocalizationProvider>
					<HorizontalDivider />
					{typeof onSubmit === "function" && (
						<CustomButton className={styles.button} variant="contained" onClick={onSubmit}>
							{submitButtonText || translate("common:btn.apply")}
						</CustomButton>
					)}
				</div>
			</DropDown>
		);
	}
);

export default CustomDateCalendarPopUp;
